import React from "react";

const NoDataSvg = () => {
  return (
    <svg
      width="400"
      height="400"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5722_12558)">
        <g opacity="0.4">
          <path
            d="M96.25 10.1787V19.5537H2.5V10.1787C2.5 6.74121 5.3125 3.92871 8.75 3.92871H90C93.4375 3.92871 96.25 6.74121 96.25 10.1787Z"
            fill="#41EAD4"
          />
          <g filter="url(#filter0_d_5722_12558)">
            <path
              d="M96.25 19.5537V122.679C96.25 126.116 93.4375 128.929 90 128.929H8.75C5.3125 128.929 2.5 126.116 2.5 122.679V19.5537H96.25Z"
              fill="#F4F8FF"
            />
          </g>
          <path
            d="M77.2319 50.5361H20.9819C19.2632 50.5361 17.8569 49.1299 17.8569 47.4111C17.8569 45.6924 19.2632 44.2861 20.9819 44.2861H77.2319C78.9507 44.2861 80.3569 45.6924 80.3569 47.4111C80.3569 49.1299 78.9507 50.5361 77.2319 50.5361Z"
            fill="#A7F9F9"
          />
          <path
            d="M77.2319 69.6436H20.9819C19.2632 69.6436 17.8569 68.2373 17.8569 66.5186C17.8569 64.7998 19.2632 63.3936 20.9819 63.3936H77.2319C78.9507 63.3936 80.3569 64.7998 80.3569 66.5186C80.3569 68.2373 78.9507 69.6436 77.2319 69.6436Z"
            fill="#A7F9F9"
          />
          <path
            d="M77.2319 88.75H20.9819C19.2632 88.75 17.8569 87.3438 17.8569 85.625C17.8569 83.9062 19.2632 82.5 20.9819 82.5H77.2319C78.9507 82.5 80.3569 83.9062 80.3569 85.625C80.3569 87.3438 78.9507 88.75 77.2319 88.75Z"
            fill="#A7F9F9"
          />
          <path
            d="M77.2319 107.857H20.9819C19.2632 107.857 17.8569 106.451 17.8569 104.732C17.8569 103.014 19.2632 101.607 20.9819 101.607H77.2319C78.9507 101.607 80.3569 103.014 80.3569 104.732C80.3569 106.451 78.9507 107.857 77.2319 107.857Z"
            fill="#A7F9F9"
          />
        </g>
        <g opacity="0.4">
          <path
            d="M198.929 74.4639V83.8389H105.179V74.4639C105.179 71.0264 107.991 68.2139 111.429 68.2139H192.679C196.116 68.2139 198.929 71.0264 198.929 74.4639Z"
            fill="#41EAD4"
          />
          <g filter="url(#filter1_d_5722_12558)">
            <path
              d="M198.929 83.8389V186.964C198.929 190.401 196.116 193.214 192.679 193.214H111.429C107.991 193.214 105.179 190.401 105.179 186.964V83.8389H198.929Z"
              fill="#F4F8FF"
            />
          </g>
          <path
            d="M180.089 117.679H123.839C122.121 117.679 120.714 116.272 120.714 114.554C120.714 112.835 122.121 111.429 123.839 111.429H180.089C181.808 111.429 183.214 112.835 183.214 114.554C183.214 116.272 181.808 117.679 180.089 117.679Z"
            fill="#A7F9F9"
          />
          <path
            d="M180.089 136.786H123.839C122.121 136.786 120.714 135.38 120.714 133.661C120.714 131.942 122.121 130.536 123.839 130.536H180.089C181.808 130.536 183.214 131.942 183.214 133.661C183.214 135.38 181.808 136.786 180.089 136.786Z"
            fill="#A7F9F9"
          />
          <path
            d="M180.089 155.893H123.839C122.121 155.893 120.714 154.486 120.714 152.768C120.714 151.049 122.121 149.643 123.839 149.643H180.089C181.808 149.643 183.214 151.049 183.214 152.768C183.214 154.486 181.808 155.893 180.089 155.893Z"
            fill="#A7F9F9"
          />
          <path
            d="M180.089 175H123.839C122.121 175 120.714 173.594 120.714 171.875C120.714 170.156 122.121 168.75 123.839 168.75H180.089C181.808 168.75 183.214 170.156 183.214 171.875C183.214 173.594 181.808 175 180.089 175Z"
            fill="#A7F9F9"
          />
        </g>
        <path
          d="M146.875 46.875V56.25H53.125V46.875C53.125 43.4375 55.9375 40.625 59.375 40.625H140.625C144.062 40.625 146.875 43.4375 146.875 46.875Z"
          fill="#52DBC9"
        />
        <g filter="url(#filter2_d_5722_12558)">
          <path
            d="M146.875 56.25V159.375C146.875 162.812 144.062 165.625 140.625 165.625H59.375C55.9375 165.625 53.125 162.812 53.125 159.375V56.25H146.875Z"
            fill="#F4F8FF"
          />
        </g>
        <path
          d="M68.8944 92.075C71.0453 92.075 72.7889 90.3314 72.7889 88.1806C72.7889 86.0297 71.0453 84.2861 68.8944 84.2861C66.7436 84.2861 65 86.0297 65 88.1806C65 90.3314 66.7436 92.075 68.8944 92.075Z"
          fill="#F6B550"
        />
        <path
          d="M68.8944 108.037C71.0453 108.037 72.7889 106.293 72.7889 104.142C72.7889 101.992 71.0453 100.248 68.8944 100.248C66.7436 100.248 65 101.992 65 104.142C65 106.293 66.7436 108.037 68.8944 108.037Z"
          fill="#F6B550"
        />
        <path
          d="M68.8944 123.999C71.0453 123.999 72.7889 122.255 72.7889 120.104C72.7889 117.954 71.0453 116.21 68.8944 116.21C66.7436 116.21 65 117.954 65 120.104C65 122.255 66.7436 123.999 68.8944 123.999Z"
          fill="#F6B550"
        />
        <path
          d="M68.8944 139.961C71.0453 139.961 72.7889 138.217 72.7889 136.066C72.7889 133.915 71.0453 132.172 68.8944 132.172C66.7436 132.172 65 133.915 65 136.066C65 138.217 66.7436 139.961 68.8944 139.961Z"
          fill="#F6B550"
        />
        <path
          d="M125.661 91.0089H80.8834C79.8071 91.0089 78.936 90.138 78.936 89.0616C78.936 87.9853 79.8069 87.1143 80.8834 87.1143H125.661C126.737 87.1143 127.608 87.9851 127.608 89.0616C127.608 90.138 126.737 91.0089 125.661 91.0089Z"
          fill="#52DBC9"
        />
        <path
          d="M112.039 106.319H80.8834C79.8071 106.319 78.936 105.449 78.936 104.372C78.936 103.296 79.8069 102.425 80.8834 102.425H112.039C113.115 102.425 113.986 103.296 113.986 104.372C113.986 105.449 113.115 106.319 112.039 106.319Z"
          fill="#52DBC9"
        />
        <path
          d="M88.6722 121.63H80.8834C79.8071 121.63 78.936 120.759 78.936 119.683C78.936 118.606 79.8069 117.735 80.8834 117.735H88.6722C89.7484 117.735 90.6195 118.606 90.6195 119.683C90.6193 120.759 89.7484 121.63 88.6722 121.63Z"
          fill="#52DBC9"
        />
        <path
          d="M131.929 121.326H95.7757C94.8675 121.326 94.1323 120.591 94.1323 119.682C94.1323 118.774 94.8673 118.039 95.7757 118.039H131.929C132.837 118.039 133.572 118.774 133.572 119.682C133.572 120.591 132.837 121.326 131.929 121.326Z"
          fill="#52DBC9"
        />
        <path
          d="M111.401 137.133H81.8875C80.2563 137.133 78.936 136.22 78.936 135.09C78.936 133.961 80.256 133.047 81.8875 133.047H111.401C113.032 133.047 114.352 133.961 114.352 135.09C114.352 136.22 113.032 137.133 111.401 137.133Z"
          fill="#52DBC9"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5722_12558"
          x="-3.05584"
          y="19.5537"
          width="121.529"
          height="137.154"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8.33377" dy="13.8896" />
          <feGaussianBlur stdDeviation="6.94481" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5722_12558" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5722_12558"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5722_12558"
          x="88.432"
          y="71.3778"
          width="121.529"
          height="137.154"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.85714" dy="1.42857" />
          <feGaussianBlur stdDeviation="6.94481" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5722_12558" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5722_12558"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5722_12558"
          x="47.5692"
          y="56.25"
          width="121.529"
          height="137.154"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8.33377" dy="13.8896" />
          <feGaussianBlur stdDeviation="6.94481" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5722_12558" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5722_12558"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_5722_12558">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoDataSvg;
